import { render, staticRenderFns } from "./UserMescanDataComparison.vue?vue&type=template&id=0a789614&scoped=true"
import script from "./UserMescanDataComparison.vue?vue&type=script&lang=js"
export * from "./UserMescanDataComparison.vue?vue&type=script&lang=js"
import style0 from "./UserMescanDataComparison.vue?vue&type=style&index=0&id=0a789614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a789614",
  null
  
)

export default component.exports